import React, { FunctionComponent, Fragment } from 'react';
import { Grid, Typography } from '@rbx/ui';
import { TEndpoint } from '@rbx/docsite-utilities/dist/browser';
import StandardMarkdownNoMargin from '@modules/ui/markdown/components/StandardMarkdownNoMargin';
import { OpenAPIData2Content } from '@modules/utilities/pageBuild/content';
import { useTranslation } from '@rbx/intl';
import Endpoint from './roas/CloudV2Endpoint';
import Layout from './roas/Layout';
import SchemaTable from './roas/SchemaTable';
import SchemasProvider, { TSchema } from './roas/SchemasProvider';
import ResourceProvider from './roas/ResourceProvider';

type RoasOpenCloudContentProps = {
  content: OpenAPIData2Content;
};

const RoasOpenCloudContent: FunctionComponent<
  React.PropsWithChildren<RoasOpenCloudContentProps>
> = ({ content }) => {
  const { translate } = useTranslation();

  const {
    schemas,
    serverUrl,
    name: resourceName,
    refName: resourceRefName,
    description,
    endpoints,
    exampleValue,
  } = content;

  return (
    <SchemasProvider schemas={schemas as unknown as Record<string, TSchema>}>
      <ResourceProvider refName={resourceName}>
        <Grid container direction='column' paddingBottom={8}>
          <Fragment key={resourceName}>
            <Layout
              showResourceName
              resourceName={resourceName}
              codeSamples={[
                {
                  title: translate('Label.BaseURL'),
                  content: serverUrl,
                },
                {
                  title: translate('Label.TheResource', { resourceName }),
                  content: exampleValue ?? '',
                  language: 'json',
                },
              ]}>
              {description && <StandardMarkdownNoMargin>{description}</StandardMarkdownNoMargin>}
              <Typography marginTop={5} variant='h3' component='h3'>
                {translate('Label.Attributes')}
              </Typography>
              <SchemaTable refName={resourceRefName} />
            </Layout>

            {endpoints.map((endpoint: TEndpoint) => (
              <Endpoint
                key={endpoint.operationId}
                endpoint={endpoint}
                resourceRefName={resourceRefName}
                resourceName={resourceName}
              />
            ))}
          </Fragment>
        </Grid>
      </ResourceProvider>
    </SchemasProvider>
  );
};

export default RoasOpenCloudContent;
